import { FormGroup, Input, Label } from 'reactstrap';

import { formatDateKey, formatTime } from 'src/shared/utils/datetime';
import { formatMoney } from 'src/shared/utils/money';
import { formatDuration } from '../calendarUtils';
import type { BookingForm } from './useBookingForm';

interface BookingSummaryProps {
  form: BookingForm;
  timeZone?: string;
  currency?: string;
}

/** What will be booked, read back in full before confirming, plus the notes. */
export default function BookingSummary({ form, timeZone, currency }: BookingSummaryProps) {
  const ends =
    form.startsAt !== ''
      ? new Date(new Date(form.startsAt).getTime() + form.totalMinutes * 60_000).toISOString()
      : '';

  return (
    <div>
      <dl className="v-summary">
        <div>
          <dt>Clienta</dt>
          <dd>{form.client?.fullName ?? '—'}</dd>
        </div>
        <div>
          <dt>Servicios</dt>
          <dd>
            {form.chosen.length > 0 ? form.chosen.map((service) => service.name).join(' · ') : '—'}
          </dd>
        </div>
        <div>
          <dt>Cuándo</dt>
          <dd>
            <span className="v-first-cap">
              {formatDateKey(form.date, { weekday: 'long', day: 'numeric', month: 'long' })}
            </span>
            {form.startsAt !== '' && (
              <>
                {' '}
                · {formatTime(form.startsAt, timeZone)}–{formatTime(ends, timeZone)}
              </>
            )}
          </dd>
        </div>
        <div>
          <dt>Total</dt>
          <dd className="v-money">
            {formatMoney(form.totalPrice, currency)}
            {form.totalMinutes > 0 && (
              <span className="text-muted"> · {formatDuration(form.totalMinutes)}</span>
            )}
          </dd>
        </div>
      </dl>

      <FormGroup className="mb-0">
        <Label for="bookNotes">Notas</Label>
        <Input
          id="bookNotes"
          type="textarea"
          rows={2}
          placeholder="Qué pidió la clienta: forma, color, diseño…"
          value={form.notes}
          onChange={(e) => form.setNotes(e.target.value)}
        />
      </FormGroup>
    </div>
  );
}
